export class DocumentInfo {
  constructor(
    public id?: number,
    public filename?: string,
    public extension?: string,
    public type?: string,
    public file?: File
  ) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/models/document-info.ts